import React, { useCallback, useState } from 'react'
import Countdown, { type CountdownRenderProps } from 'react-countdown'
import moment from 'moment'
import { codeInputMask, focusMaskStart } from 'utils/masks'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { ShadowInput } from 'components/FormElements/ShadowInput/ShadowInput'
import styles from '../Form.module.scss'

type ConfirmPhoneFormProps = {
  /** When a new code may be requested */
  reclaimAt: string | null,
  onSubmit: (form: { code: string }) => void,
  onResend: () => void,
  isSubmitting?: boolean,
  confirmButtonText?: string,
}

const pad = (value: number) => value.toString().padStart(2, '0')

/** The SMS code step, with a countdown until the code can be sent again */
export const ConfirmPhoneForm: React.FC<ConfirmPhoneFormProps> = (props) => {
  const { reclaimAt, onSubmit, onResend, isSubmitting, confirmButtonText = 'Подтвердить' } = props
  const [code, setCode] = useState('')

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault()
    onSubmit({ code })
  }, [code, onSubmit])

  const renderCountdown = useCallback(({ minutes, seconds, completed }: CountdownRenderProps) => {
    if (completed) {
      return <span onClick={(e) => {
        e.preventDefault()
        setCode('')
        onResend()
      }}>Получить код повторно</span>
    }
    return <span>Запросить код повторно можно через {pad(minutes)}:{pad(seconds)}</span>
  }, [onResend])

  return (
    <form noValidate onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.fields}>
        <div className={styles.note}>
          Введите код из смс
        </div>
        <ShadowInput
          onFocus={focusMaskStart}
          mask={codeInputMask}
          onChange={setCode}
          value={code}
          className={styles.field}
          shadowColor={'purple'}
        />
        <div className={styles.resend}>
          <Countdown
            key={reclaimAt ?? undefined}
            date={moment(reclaimAt).toDate()}
            renderer={renderCountdown}
          />
        </div>
      </div>
      <div className={styles.actions}>
        <AppButton type={'submit'} disabled={isSubmitting} className={styles.action}>
          {confirmButtonText}
        </AppButton>
      </div>
    </form>
  )
}
